<template>
  <el-dialog title="温馨提示" :visible.sync="visibleVal" :append-to-body="true" custom-class="tipsDialog">
    <div slot="title" class="dialog-header">
      <span class="dialog-title">温馨提示</span>
      <span class="icon-portal-close" @click="visibleVal=false"></span>
    </div>
    <div class="dialog-content">
      <p>{{message}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sureClick">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "tipsDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rectOptions: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      activeIndex: 0,
      message: ""
    }
  },
  created() {
  },
  watch: {
  },
  computed: {
    visibleVal: {
      get(){
        return this.visible
      },
      set(val){
        this.$emit("update:visible",val)
      }
    },
    websiteId() {
      return this.$store.state.getDataPageIds.websiteId
    }
  },
  mounted() {
    this.getMessage()
  },
  methods: {
    async getMessage() {
      let url = this.rectOptions.requestUrl
      if(!url){
        this.message = this.rectOptions.tipMessage
        return
      }
      const detailData = JSON.parse(window.localStorage.getItem("detailData"))
      const { id ,formId } = detailData[0]
      const { UID, current_page_id, website_id, website_fid } = this.$store.state.states.myCookie
      if (!UID) {
        this.message = "请先登录再投递。"
        return
      }
      if (url) {
        let params = {
          pageId: current_page_id,
          fid: website_fid,
          websiteId: website_id,
          id: id,
          formId: formId ? formId : "",
          uid: UID ? UID : ""
        }
        this.instance.post(url,params).then(res=>{
          this.message = res.data.message
        })
      }
    },
    sureClick() {
      this.visibleVal = false
    }
  }
}
</script>

<style scoped>
::v-deep .tipsDialog {
  width: 400px;
}
::v-deep .tipsDialog .dialog-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
}
::v-deep .tipsDialog .el-dialog__body {
  height: 100px;
  overflow: auto;
  padding: 8px 0;
}
::v-deep .tipsDialog .el-dialog__headerbtn {
  display: none;
}
::v-deep .tipsDialog .icon-portal-close {
  position: absolute;
  right: 18px;
  top: 18px;
  font-size: 16px;
  cursor: pointer;
}
::v-deep .tipsDialog .dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  max-width: 90%;
}

::v-deep .tipsDialog .dialog-content .text{
  text-align: center;
  color: rgba(0,0,0,0.8);
}
</style>
